import React, { ChangeEvent, CSSProperties, useMemo, useRef } from "react";
import { classNames } from "@ct-react/core";
import "./selectors.scss";

type Props = {
  minMax?: boolean;
  limit: [ number, number ];
  resume: (value: number) => string;
  step?: number;
  value?: number | [ number, number ];
  onChange?: (value?: any) => void;
}

const SearchItemSelectorRange = (
  {
    minMax = false,
    limit,
    resume,
    step = 1,
    value,
    onChange = () => void 0
  }: Props) => {

  const minResumeRef = useRef<HTMLSpanElement>(null);
  const maxResumeRef = useRef<HTMLSpanElement>(null);

  const handleChange = (e: ChangeEvent<HTMLInputElement>, type: "min" | "max") => {
    if (type === "max") {
      onChange([ !!value ? value[0] : limit[0], +e.target.value ]);
    } else if (minMax) {
      onChange([ +e.target.value, !!value ? value[1] : limit[1]])
    } else {
      onChange(+e.target.value);
    }
  }

  const positions = useMemo(() => {
    const start = (!value || (minMax ? value[0] : value) === limit[0]) ? 0 : ((value[0] || value) - limit[0]) * 100 / (limit[1] - limit[0]);
    const end = (!minMax || !value || value[1] === limit[1]) ? 100 : (value[1] - limit[0]) * 100 / (limit[1] - limit[0]);
    return {
      "--range-start": `${start}%`,
      "--range-end": `${end}%`
    };
  }, [ value ]);

  const wrapperClasses = classNames("range-label", { "min-max": minMax });

  return (
    <label className={wrapperClasses}
           style={positions as CSSProperties}>
      <div className="bar" />
      <input className="min"
             type="range"
             min={limit[0]}
             max={limit[1]}
             step={step}
             value={!!value ? (minMax ? value[0] : value) : limit[0]}
             onChange={e => handleChange(e, "min")} />
      <span ref={minResumeRef}
            className="resume-label min"
            style={{ "--my-size": `${minResumeRef.current?.clientWidth || 0}px` } as CSSProperties}>
        {resume(!!value ? (minMax ? value[0] : value) : limit[0])}
      </span>
      {minMax &&
        <>
          <input className="max"
                 type="range"
                 min={limit[0]}
                 max={limit[1]}
                 step={step}
                 value={!!value ? value[1] : limit[1]}
                 onChange={e => handleChange(e, "max")} />
          <span ref={maxResumeRef}
                className="resume-label max"
                style={{ "--my-size": `${maxResumeRef.current?.clientWidth || 0}px` } as CSSProperties}>
            {resume(!!value ? value[1] : limit[1])}
          </span>
        </>
      }
    </label>);

}

export default SearchItemSelectorRange;
